import request from '../utils/request'

export function pVentasRequest(data) {
    return request({
        url: 'dashboard/pventas',
        method: 'post',
        data
    })
}

export function invoicesRequest(data) {
    return request({
        url: 'dashboard/invoices',
        method: 'post',
        data
    })
}

export function findAllRequest(data) {
    return request({
        url: 'dashboard/findAll/invoices',
        method: 'post',
        data
    })
}

export function typeInvoicesRequest(data) {
    return request({
        url: `dashboard/invoices/by/pventa`,
        method: 'post',
        data
    })
}

export function updateInvoicesRequest(data) {
    return request({
        url: `/check-in/update`,
        method: 'post',
        data
    })
}

export function ErrosInvoicesRequest(data) {
    return request({
        url: `/check-in/errors`,
        method: 'post',
        data
    })
}
